import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, UserCheck, Award } from 'lucide-react';
const advantages = [{
  icon: <Sparkles strokeWidth={1} size={40} data-id="element-43" />,
  title: 'Преміальні матеріали',
  description: "Використовую лише перевірену косметику світових брендів, щоб зберегти здоров'я та природний блиск вашого волосся."
}, {
  icon: <UserCheck strokeWidth={1} size={40} data-id="element-44" />,
  title: 'Індивідуальний підхід',
  description: 'Підбираю форму стрижки та відтінки фарбування, враховуючи ваші риси обличчя, структуру волосся та стиль життя.'
}, {
  icon: <Award strokeWidth={1} size={40} data-id="element-45" />,
  title: 'Багаторічний досвід',
  description: "Понад 12 років безперервної практики та регулярне підвищення кваліфікації у кращих майстрів б'юті-індустрії."
}];
export function Advantages() {
  return <section className="py-32 bg-white" data-id="element-46">
      <div className="container mx-auto px-6 md:px-12" data-id="element-47">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-48">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-49">
            Чому обирають мене?
          </h2>
          <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-50"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16" data-id="element-51">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="flex flex-col items-center text-center" data-id="element-52">
              <div className="text-ink mb-8 p-4 bg-surface rounded-full border border-line shadow-sm" data-id="element-53">
                {adv.icon}
              </div>
              <h3 className="text-xl font-semibold text-ink mb-4 tracking-tight" data-id="element-54">
                {adv.title}
              </h3>
              <p className="text-muted font-normal text-base leading-relaxed" data-id="element-55">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}